<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Perquisite"
      text="Create Perquisite"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="perquisite"
                v-validate="'required'"
                :items="benefitInKinds"
                item-text="name"
                item-value="id"
                label="Perquisite"
                :error-messages="errors.collect('perquisite')"
                data-vv-name="perquisite"  
                data-vv-as="perquisite"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="taxExemption"
                :items="taxExemptions"
                item-text="name"
                item-value="id"
                label="Tax Exemption"
                data-vv-as="taxExemption"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"
                    data-vv-as="start date"
                    label="Start date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  :min="companyEmployeeStartDate"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container> 
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"     
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      companyEmployeeUid: {
        type: String,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        loading: false,
        progressing: false,
        dialog: false,
        amount: null,
        benefitInKinds: [],
        perquisite: null,
        taxExemptions: [],
        taxExemption: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 
        this.loading = true
 
        Promise.all([
          this.$api.benefitInKinds().list('?filter[type]=perquisite'),
          this.$api.taxExemptions().list({ year: this.yearFilter }),
        ])
          .then(([perquisite, taxExemption]) => {
            this.benefitInKinds = _.orderBy(perquisite.data, ['name'], ['asc'])
            this.taxExemptions = _.orderBy(taxExemption.data, ['name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true

            this.$api.companyEmployeePerquisites().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        return {
          benefit_in_kind_id: this.perquisite,
          start_date: this.startDate,
          tax_exemption_id: this.taxExemption,
          amount: this.amount.toString().replaceAll(',', ''),
          end_date: this.startDate,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
